import { Box } from '@mui/material';
import React from 'react';

import { SectionHeader } from '@/components';
import { OrganisationActiveInvitation } from '@/types/organisations';

import SentInvitationItem from './components';
import { Props } from './types';

const sortSentInvitations = (invitations: OrganisationActiveInvitation[]) =>
    [...invitations].sort((a, b) => {
        return a.created_at - b.created_at;
    });

const SentInvitations: React.FC<Props> = ({
    organisationActiveInvitations,
}) => {
    return (
        <Box>
            <SectionHeader title="Sent Invitations" />

            <Box
                component="ul"
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: '12px',
                    m: '16px',
                    maxHeight: '320px',
                    overflow: 'auto',
                }}
            >
                {sortSentInvitations(organisationActiveInvitations).map(
                    (invitation) => (
                        <SentInvitationItem
                            key={invitation.id}
                            invitation={invitation}
                        />
                    ),
                )}
            </Box>
        </Box>
    );
};

export default SentInvitations;
